import API from './API.js'

export default class Nationality extends API {
  constructor() {
    super('nationality')
  }
}
